import './perks-merch.component.scss';

import { h } from 'preact';
import { useMemo } from 'preact/hooks';

import { SpinnerComponent } from '../../../common/components/spinner/spinner.component';
import { useTranslation } from '../../../i18n';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { ContentType } from '../../model/tab.interface';
import {
  selectMerch,
  selectPerksLoading,
  selectTabContentLast,
  selectTabContentNextCursor,
} from '../../store/perks.selectors';
import { loadTabContent } from '../../store/perks.thunk';
import { usePerksConfig } from '../perks/perks-config.context';
import { PerksProductCard } from './perks-product-card.component';

export const PerksMerchComponent = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const loading = useAppSelector(selectPerksLoading);
  const merch = useAppSelector(selectMerch);
  const isLast = useAppSelector(selectTabContentLast(ContentType.PRODUCT));
  const nextCursor = useAppSelector(selectTabContentNextCursor(ContentType.PRODUCT));
  const { searchQuery, columns } = usePerksConfig();

  const cssVars = {
    '--productColumns': columns,
  };

  const filteredMerch = useMemo(() => {
    if (!merch) return [];
    const validMerch = merch.filter((item) => item.product?.id != null);
    if (!searchQuery) return validMerch;

    const query = searchQuery.toLowerCase();
    return validMerch.filter((item) => item.product?.title?.toLowerCase().includes(query));
  }, [merch, searchQuery]);

  const handleLoadMore = () => {
    dispatch(loadTabContent({ contentType: ContentType.PRODUCT, cursor: nextCursor, loadMore: true }));
  };

  if (loading && !merch?.length) {
    return (
      <section class="single-loading">
        <SpinnerComponent />
      </section>
    );
  }

  if (!merch) return null;

  return (
    <div class="single-perks-merch-container" style={cssVars}>
      {filteredMerch.length > 0 ? (
        <>
          <section class="single-card-grid">
            {filteredMerch.map((merchItem) => (
              <PerksProductCard
                key={merchItem.product.id.toString()}
                product={merchItem.product}
              />
            ))}
          </section>
          {!searchQuery && !isLast && (
            <section className="single-load-more">
              <button className="button btn" onClick={handleLoadMore} disabled={loading}>
                {loading ? t('common.loading') : t('perks.loadMore')}
              </button>
            </section>
          )}
        </>
      ) : (
        <div class="no-results">
          {t('perks.noProducts')}
          {searchQuery && <span>&nbsp;{t('perks.foundFor', { query: searchQuery })}</span>}
        </div>
      )}
    </div>
  );
};
